export const constants = {
  uiDefaultLanguage: 'sv-SE',
  uiDefaultLocale: 'sv-SE'
};
